import * as stravaCommunityFeatures from './stravaCommunityFeatures'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './stravaGatherMachine'
import * as stravaMapVisibility from './stravaMapVisibility'
import * as stravaMentions from './stravaMentions'
import * as stravaNotifications from './stravaNotifications'
import * as stravaPastActvities from './stravaPastActivities'
import * as stravaVisibility from './stravaVisibility'
import { StravaRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [StravaRecommendationKey.STRAVA_COMMUNITY_FEATURES]: stravaCommunityFeatures,
  [StravaRecommendationKey.STRAVA_FOLLOWERS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        StravaRecommendationKey.STRAVA_FOLLOWERS,
      ),
    ],
  },
  [StravaRecommendationKey.STRAVA_MAP_VISIBILITY]: stravaMapVisibility,
  [StravaRecommendationKey.STRAVA_MENTIONS]: stravaMentions,
  [StravaRecommendationKey.STRAVA_NOTIFICATIONS]: stravaNotifications,
  [StravaRecommendationKey.STRAVA_PASSWORD]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        StravaRecommendationKey.STRAVA_PASSWORD,
      ),
    ],
  },
  [StravaRecommendationKey.STRAVA_PAST_ACTIVITIES]: stravaPastActvities,
  [StravaRecommendationKey.STRAVA_VISIBILITY]: stravaVisibility,
}

export const stravaRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
